/* globals diy, Klazz */
var $ = require('jquery');

var NotificationBase;

NotificationBase = Klazz.extend({
    flashNotification: false,
    _resource: null,
    /**
     * override this in concrete classes
     */
    stickyDefault: 0,
    /**
     * override this in concrete classes
     */
    categoryDefault: null,
    /**
     * override this in concrete classes
     */
    severityDefault: null,
    severityClass: {
        1: 'severity-high',
        2: 'severity-medium-high',
        3: 'severity-medium',
        4: 'severity-medium-low',
        5: 'severity-low'
    },
    bubbleHideDelay: {
        1: 0,
        2: 7000,
        3: 7000,
        4: 7000,
        5: 7000
    },
    bubbleOptions: {
        'autoHide': true,
        'hideDelay': 4000,
        'dismissCallback': null
    },
    /**
     *
     */
    softDeletion: false,
    /**
     *
     */
    iconCls: null,
    /**
     * this method must be implemented by all Notifications
     */
    getContent: function() {

    },

    initialize: function(resource) {
        if (!this.flashNotification && resource) {
            this.setResource(resource);
        }
        this.setBubbleOptions();
    },

    getBubbleOptions: function() {
        return this.bubbleOptions;
    },
    getBubbleOption: function(opt) {
        return this.bubbleOptions[opt];
    },
    setBubbleOptions: function(/*options*/) {
        this.bubbleOptions = {
            'autoHide': (this.bubbleHideDelay[this.getSeverity()] !== 0),
            'hideDelay': this.bubbleHideDelay[this.getSeverity()]
        };
        /*if (options && options.autoHide) {
            this.bubbleOptions.autoHide = options.autoHide?true:false;
        }
        if (options && options.hideDelay && !isNaN(options.hideDelay)) {
            this.bubbleOptions.hideDelay = options.hideDelay;
        }*/
        this.bubbleOptions.dismissCallback = $.proxy(function() {
            if (!this.flashNotification) {
                this.setDismissed(1);
                this._resource.$update();
            }
        }, this)
    },

    /**
     * Css class suffix to be appended to each notification entry
     * Results in a css class like 'notification-type-*'
     * @returns {string}
     */
    getCssClassSuffix: function() {
        return '';
    },

    getSeverityClass: function() {
        return this.severityClass[this.getSeverity()];
    },

    setResource: function(resource) {
        this._resource = resource;
    },
    getResource: function() {
        return this._resource;
    },

    getOption: function(opt) {
        var defaults = {
            'id': null,
            'category': this.categoryDefault,
            'severity': this.severityDefault,
            'sticky': this.stickyDefault,
            'dismissed': 0,
            'read': 0,
            'deleted': 0,
            'payload': null
        };
        if (this._resource && !(typeof this._resource[opt] == 'undefined')) {
            return this._resource[opt];
        }
        return defaults[opt];
    },
    getId: function() {
        return this.getOption('id');
    },
    getCategory: function() {
        return this.getOption('category');
    },
    getSeverity: function() {
        return this.getOption('severity');
    },
    getSticky: function() {
        return this.getOption('sticky');
    },
    getDismissed: function() {
        return this.getOption('dismissed');
    },
    getRead: function() {
        return this.getOption('read');
    },
    getDeleted: function() {
        return this.getOption('deleted');
    },
    getPayload: function() {
        return this.getOption('payload');
    },
    getName: function() {
        throw new Error('getName must be implemented by all classes');
    },


    setOption: function(opt, value) {
        if (this._resource) {
            this._resource[opt] = value;
        }
    },
    setCategory: function(value) {
        return this.setOption('category', value);
    },
    setSeverity: function(value) {
        return this.setOption('severity', value);
    },
    setSticky: function(value) {
        return this.setOption('sticky', value);
    },
    setDismissed: function(value) {
        return this.setOption('dismissed', value);
    },
    setRead: function(value) {
        return this.setOption('read', value);
    },
    setDeleted: function(value) {
        return this.setOption('deleted', value);
    },
    setPayload: function(value) {
        return this.setOption('payload', value);
    }


});

module.exports = NotificationBase;



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/toolbar/notification/NotificationBase.js
 ** module id = 647
 ** module chunks = 0
 **/